import React from 'react';
import styles from './landing.module.css';

const LandingGMAO = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Software de Gestión de Mantenimiento (GMAO)</h1>
      <p className={styles.subtitle}>SSC by Ingertec – Optimice el mantenimiento, reduzca costos y aumente la eficiencia.</p>

      {/* Formulario */}
      <div className={styles.form}>
        <input type="text" placeholder="Nombre" className={styles.input} />
        <input type="email" placeholder="Email" className={styles.input} />
        <input type="text" placeholder="Empresa" className={styles.input} />
      </div>
      <button className={styles.button}>Solicitar Demo</button>

      {/* Features */}
      <div className={styles.features}>
        <div className={styles.feature}>
          <h3>Control Total</h3>
          <p>Gestione órdenes de trabajo, activos y recursos en un solo lugar.</p>
        </div>
        <div className={styles.feature}>
          <h3>Optimización</h3>
          <p>Reduzca tiempos muertos y costos con planificación inteligente.</p>
        </div>
        <div className={styles.feature}>
          <h3>Reportes</h3>
          <p>Acceda a métricas clave y mejore la toma de decisiones.</p>
        </div>
      </div>
    </div>
  );
};

export default LandingGMAO;
